/** Google Maps emits path changes throughout a vertex drag, including pauses.
 * Defer destructive edits until release; debounce non-pointer path edits too.
 */
export const boundaryEditCommit = (
  surface: HTMLElement,
  commit: () => void,
  delayMs: number
) => {
  const view = surface.ownerDocument.defaultView!;
  let pointerDown = false;
  let changed = false;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const clearTimer = () => {
    clearTimeout(timer);
    timer = undefined;
  };
  const flush = () => {
    clearTimer();
    if (pointerDown || !changed) return;
    changed = false;
    commit();
  };
  const onDown = () => {
    pointerDown = true;
    clearTimer();
  };
  const onRelease = () => {
    if (!pointerDown) return;
    pointerDown = false;
    // Let Maps apply its final set_at before reading the polygon.
    timer = setTimeout(flush, 0);
  };
  surface.addEventListener('pointerdown', onDown, true);
  view.addEventListener('pointerup', onRelease, true);
  view.addEventListener('pointercancel', onRelease, true);
  const cancel = () => {
    clearTimer();
    changed = false;
  };
  return {
    changed: () => {
      changed = true;
      clearTimer();
      if (!pointerDown) timer = setTimeout(flush, delayMs);
    },
    cancel,
    remove: () => {
      cancel();
      surface.removeEventListener('pointerdown', onDown, true);
      view.removeEventListener('pointerup', onRelease, true);
      view.removeEventListener('pointercancel', onRelease, true);
    },
  };
};
